import React from "react";
import { Serviceslider } from "./Serviceslider";
import Servicesmarquee from "./Servicesmarquee";

export const Servicesinage = () => {
  const serviceslider = [
    {
      service: "./images/services/a_shape_standee.webp",
      title: "A-Shaped Standee",
    },
    {
      service: "./images/services/Kiosk Signage.jpg",
      title: "LED Kiosk Display Screen",
    },
    {
      service: "./images/services/Table_Top_Display_screen.jpg",
      title: "Table Top Display screen",
    },
    {
      service: "./images/services/Outdoor_LED_Screen.jpg",
      title: "Outdoor LED Screen",
    },
    {
      service: "./images/services/LED_scrolling_board.jpg",
      title: "LED Scrolling Board",
    },    
    {
      service: "./images/services/transparent_LED_display.jpg",
      title: "Transparent LED Display",
    },
  ];

  return (
    <div>
      <Serviceslider data={serviceslider} isautoPlay={true} />
    </div>
  );
};
